import React, { Fragment } from 'react';

import './About.css';
import Contact from '../contact/Contact';

export default function About() {
    return (
        <Fragment>
            <img className='left-ellipse' src="assets/images/about/left_ellipse_dual.png" alt="ellipse_left" width={"100%"} />
            <div className='about-main-container'>
                <div className='about-hero-image'>
                    <img src="assets/images/landing/hero-image.jpg" alt="about" width={"100%"} />
                </div>
                <div className='about-text-container'>
                    <div className='about-me'>{"About Me"}
                    </div>
                    <div className='about-text'>{"With over a decade of experience in the industry, I bring unparalleled expertise in producing top-notch commercials, digital content, and short fiction films. I have had the honor of collaborating with prestigious organisations such as Publicis Groupe, Wondrlab, Fremantle Media, Endamol Shine, and more, leaving an indelible mark on every project I undertake. \n\n I believe in the power of collaboration, and I thrive on bringing ideas to life. Whether you're seeking captivating commercials that resonate with your target audience, engaging digital content that sparks conversations, or compelling short fiction films that leave a lasting impact, I am here to make it happen. Together, we will create exceptional content that drives results."}
                    </div>
                    <div className='about-image-contianer'>
                        <img src="assets/images/about/name.png" alt="about" />
                    </div>
                </div>
            </div>
            <Contact />
        </Fragment>
    );
}
